"use strict";

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetState = exports.toggleCollapse = exports.clearExportedJSON = exports.exportJSON = exports.removeMenu = exports.updateMenu = exports.createMenu = exports.removeBanner = exports.updateBanner = exports.createBanner = exports.removeBannerGroup = exports.updateBannerGroup = exports.createBannerGroup = void 0;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var createBannerGroup = function createBannerGroup(bannerGroup) {
  return {
    type: 'CREATE_BANNER_GROUP',
    payload: _objectSpread({}, bannerGroup)
  };
};

exports.createBannerGroup = createBannerGroup;

var updateBannerGroup = function updateBannerGroup(bannerGroup) {
  return {
    type: 'UPDATE_BANNER_GROUP',
    payload: _objectSpread({}, bannerGroup)
  };
};

exports.updateBannerGroup = updateBannerGroup;

var removeBannerGroup = function removeBannerGroup(id) {
  return {
    type: 'REMOVE_BANNER_GROUP',
    payload: {
      id: id
    }
  };
};

exports.removeBannerGroup = removeBannerGroup;

var createBanner = function createBanner(banner) {
  return {
    type: 'CREATE_BANNER',
    payload: _objectSpread({}, banner)
  };
};

exports.createBanner = createBanner;

var updateBanner = function updateBanner(banner) {
  return {
    type: 'UPDATE_BANNER',
    payload: _objectSpread({}, banner)
  };
};

exports.updateBanner = updateBanner;

var removeBanner = function removeBanner(id) {
  return {
    type: 'REMOVE_BANNER',
    payload: {
      id: id
    }
  };
};

exports.removeBanner = removeBanner;

var createMenu = function createMenu(menu) {
  return {
    type: 'CREATE_MENU',
    payload: _objectSpread({}, menu)
  };
};

exports.createMenu = createMenu;

var updateMenu = function updateMenu(menu) {
  return {
    type: 'UPDATE_MENU',
    payload: _objectSpread({}, menu)
  };
};

exports.updateMenu = updateMenu;

var removeMenu = function removeMenu(id) {
  return {
    type: 'REMOVE_MENU',
    payload: {
      id: id
    }
  };
};

exports.removeMenu = removeMenu;

var exportJSON = function exportJSON() {
  return {
    type: 'EXPORT_JSON',
    payload: {
      force: true
    }
  };
};

exports.exportJSON = exportJSON;

var clearExportedJSON = function clearExportedJSON() {
  return {
    type: 'EXPORT_JSON'
  };
};

exports.clearExportedJSON = clearExportedJSON;

var toggleCollapse = function toggleCollapse(entityClass) {
  var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var region = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var typeMap = {
    Menu: 'TOGGLE_COLLAPSE_MENU',
    BannerGroup: 'TOGGLE_COLLAPSE_BANNER_GROUP',
    Banner: 'TOGGLE_COLLAPSE_BANNER'
  };
  return {
    type: typeMap[entityClass] || 'TOGGLE_COLLAPSE',
    payload: {
      id: id,
      region: region
    }
  };
};

exports.toggleCollapse = toggleCollapse;

var resetState = function resetState() {
  return {
    type: 'RESET_STATE',
    payload: {}
  };
};

exports.resetState = resetState;